import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Container, LocaleBTN } from './styles';

interface Props {
  selectLocaleToSave: () => void;
  preferredLocale: string;
}

const LanguageSelector = ({ selectLocaleToSave, preferredLocale }: Props) => (
  <Container>
    {preferredLocale === 'en' ? (
      <LocaleBTN type="button" onClick={selectLocaleToSave} value="fr">
        {ReactHtmlParser('Français')}
      </LocaleBTN>
    ) : (
      <LocaleBTN type="button" onClick={selectLocaleToSave} value="en">
        {ReactHtmlParser('English')}
      </LocaleBTN>
    )}
  </Container>
);

export default LanguageSelector;
